<section class="key-platform-features" aria-labelledby="key-platform-features-title">
  <div class="key-platform-features--container">
    <div class="key-platform-features--header">
      <span class="key-platform-features--accent" aria-hidden="true"></span>
      <h2 id="key-platform-features-title" class="key-platform-features--title">Key Platform Features</h2>
      <span class="key-platform-features--line" aria-hidden="true"></span>
    </div>

    <div class="key-platform-features--grid">
      @for (feature of features; track feature.id) {
        <article class="feature-card">
          <div class="feature-card--icon">
            <img [src]="feature.icon" [alt]="feature.title" class="feature-card--icon-img" />
          </div>
          <div class="feature-card--text">
            <h3 class="feature-card--title">{{ feature.title }}</h3>
            <p class="feature-card--description">{{ feature.description }}</p>
          </div>
        </article>
      }
    </div>
  </div>
</section>
